import React, { useState, useEffect } from 'react'
import { createUseStyles } from 'react-jss'
import clsx from 'clsx'
import { useGLTF } from "@react-three/drei";


import { AudioProvider } from './contexts/AudioContext'

import { ReactComponent as Every1Logo } from './assets/EVERY1.svg'
import { ReactComponent as IOLogo } from './assets/IO.svg'
import { ReactComponent as InfoIcon } from './assets/info.svg'

import { LG } from './constants/mediaQueries'

import Layout from './components/Layout'
import TypeWriter from './components/TypeWriter'
import Tamagoci from './components/Tamagoci'
import Modal from './components/Modal'
import BackgroundBlur from './components/BackgroundBlur'
import Credits from './components/Credits'

const everyOneLogoHeight = 122
const everyOneLogoHeightMobile = 76.25 // ~ 37.5% smaller than desktop
const ioLogoHeight = 40
const ioLogoHeightMobile = 30
const mobilePadding = 52
const desktopPadding = 69

const useStyles = createUseStyles({
  header: {
    position: 'relative',
    zIndex: 3,
    transition: 'transform 2s ease-in-out',
    transform: `translateY(calc(50dvh - ${mobilePadding}px - ${everyOneLogoHeightMobile}px - 10px))`,
    [LG]: {
      transform: `translateY(calc(50dvh - ${desktopPadding}px - ${everyOneLogoHeight}px - 12px))`
    }
  },
  footer: {
    position: 'relative',
    zIndex: 3,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '51.38%',
    transition: 'transform 2s ease-out',
    transform: `translateY(calc(-50dvh + ${mobilePadding}px + ${ioLogoHeightMobile}px + 10px))`,
    [LG]: {
      transform: `translateY(calc(-50dvh + ${desktopPadding}px + ${ioLogoHeight}px + 12px))`
    }
  },
  resetTransform: {
    transform: 'initial',
    [LG]: {
      transform: 'initial'
    }
  },
  subtitle: {
    textTransform: 'uppercase',
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Ubuntu',
    letterSpacing: 0.85,
    marginTop: 10,

    [LG]: {
      marginTop: 20,
      fontSize: 20
    }
  },
  everyOneLogo: {
    height: everyOneLogoHeightMobile,

    [LG]: {
      height: everyOneLogoHeight
    }
  },
  ioLogo: {
    height: ioLogoHeightMobile,
    [LG]: {
      height: ioLogoHeight
    }
  },
  startButton: {
    position: 'absolute',
    bottom: '21.48%',
    width: 100,
    height: 50,
    fontFamily: 'Ubuntu',
    textTransform: 'uppercase',
    fontSize: 20,
    color: '#fff',
    background: 'transparent',
    border: '1px solid #fff',
    borderRadius: 5,
    textDecoration: 'none',
    transition: 'background-color 0.68s ease-in-out',
    cursor: 'pointer',
    [LG]: {
      bottom: '22.27%',
      borderRadius: 10,
    },
    '&:hover, &:focus': {
      transition: '0.25s',
      boxShadow: 'inset 0 -3.25em 0 0 #fff',
      borderColor: ' #fff',
      color: '#000',
    }
  },
  infoIcon: {
    position: 'absolute',
    right: 50,
    bottom: 54,
    cursor: 'pointer',
    zIndex: 999,
    [LG]: {
      right: 'min(25.69%, 370px)',
      bottom: 76
    },
    '&:hover, &:focus': {
      stroke: '#fff'
    }
  }
})

export default function App() {
  const classes = useStyles()
  const [started, setStarted] = useState(false)
  const [infoVisible, setInfoVisible] = useState(false)

  const toggleStart = () => setStarted(!started)

  const toggleInfo = () => setInfoVisible(!infoVisible)

  useEffect(() => {
    useGLTF.preload("/tamagotchi11.glb");
  }, []);

  return (
    <AudioProvider>
      <Layout>
        <div className={clsx(classes.header, { [classes.resetTransform]: started })}>
          <Every1Logo className={classes.everyOneLogo} />
        </div>

        <Tamagoci visible={started} moveBack={infoVisible} />

        <div className={clsx(classes.footer, { [classes.resetTransform]: started })}>
          <IOLogo className={classes.ioLogo} />
        </div>
        {!started && (
          <button className={classes.startButton} onClick={toggleStart}>
            Start
          </button>
        )}
        <BackgroundBlur visible={infoVisible} />
        <Modal visible={infoVisible} onClose={toggleInfo}>
          <Credits />
        </Modal>
        {started && !infoVisible && <InfoIcon className={classes.infoIcon} onClick={toggleInfo} />}
      </Layout>
    </AudioProvider>
  )
}
